import { Box, IconButton } from '@mui/material';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { useTranslation } from 'react-i18next';
import { color } from 'theme';
import IconCalendarDatePicker from '../DateRangePickerCC/IconCalendar';
import './DatePickerCC.css';
import { useDispatch, useSelector } from 'react-redux';
import { updateCurrentDay } from 'pages/manager-meeting/managerMeetingSlice';
import { CALENDAR_VIEW, SLICE_NAME } from 'constants/common';
import TooltipCC from '../TooltipCC';

export const RANGE_TIME_DATEPICKER = {
    DAY: 'DAY',
    WEEK: 'WEEK'
}

const DatePickerCC = ({ maxDate = false, setDiffTime, handleChangeTimeInCalendar, diffTime }) => {

    const { t } = useTranslation()
    const inputDatePickerCCRef = useRef(null)
    const dispatch = useDispatch()
    const { currentDay } = useSelector(state => state[SLICE_NAME.MANAGER_MEETING])
    const [focusInput, setFocusInput] = useState('')

    const handleFocusInput = () => {
        setFocusInput("daterange-container-focus")
    }

    const handleOpenDatepickerCC = () => {
        inputDatePickerCCRef.current?.ref?.focus()
    }

    const handleHide = (event, picker) => {
        try {
            let pickerStartDate = picker.startDate;
            if(pickerStartDate.day() === 0){
                pickerStartDate.subtract(1, 'days')
            }

            let diff = moment(picker.startDate).isoWeek() - moment(diffTime.current).isoWeek();
            if(true) {
                dispatch(updateCurrentDay(moment(pickerStartDate)))
                handleChangeTimeInCalendar(CALENDAR_VIEW.TIME_GRID_WEEK, '', pickerStartDate.day(1).startOf('day').unix() * 1000, pickerStartDate.day(7).endOf('day').unix() * 1000)
                setDiffTime((prev) => {
                    return {
                        ...prev,
                        diff: diff
                    }
                })
            }
        } catch (error) {
            console.log("Error: ", error)
        }
        // if(moment(timeValue.start).diff(moment(picker.startDate._d).day(1).toDate(), 'day') !== 0) {
        //     dispatch(updateCurrentDay(picker.startDate._d))
        //     handleChangeTimeInCalendar(CALENDAR_VIEW.TIME_GRID_WEEK, '', moment(picker.startDate._d).day(1).startOf('day').unix() * 1000, moment(picker.startDate._d).day(7).endOf('day').unix() * 1000)
        //     setDiffTime((prev) => {

        //         return {
        //             ...prev,
        //             diff: Math.round(moment(picker.startDate._d).diff(prev.current, 'week'))
        //         }
        //     })
        //     setTimeValue({
        //         start: moment(picker.startDate._d).day(1).toDate(),
        //         end: moment(picker.startDate._d).day(7).toDate()
        //     })
        // }
        picker.element.val(moment(picker.startDate._d).day(1).format('DD/MM/YYYY') + ' - ' + moment(picker.startDate._d).day(7).format('DD/MM/YYYY'))
        inputDatePickerCCRef.current.setStartDate(moment(picker.startDate._d).day(1).toDate())
        inputDatePickerCCRef.current.setEndDate(moment(picker.startDate._d).day(7).toDate())
        setFocusInput('')
    };

    useEffect(() => {
        if(inputDatePickerCCRef.current) {
            inputDatePickerCCRef.current.setStartDate(moment().day(1).toDate())
            inputDatePickerCCRef.current.setEndDate(moment().day(7).toDate())
            inputDatePickerCCRef.current.ref.value = moment().day(1).format('DD/MM/YYYY') + ' - ' + moment().day(7).format('DD/MM/YYYY')
        }
    }, [])
    
    useEffect(() => {
        if(inputDatePickerCCRef.current) {
            inputDatePickerCCRef.current.setStartDate(moment(currentDay).day(1).toDate())
            inputDatePickerCCRef.current.setEndDate(moment(currentDay).day(7).toDate())
            inputDatePickerCCRef.current.ref.value = moment(currentDay).day(1).format('DD/MM/YYYY') + ' - ' + moment(currentDay).day(7).format('DD/MM/YYYY')
        }
    }, [currentDay])

    return (
        <Box className={`${focusInput} daterange-container`} sx={{ borderRadius: 1.5, border: '1px solid #AAA', backgroundColor: color.white, p: '1px 4px 1px 9px', display: 'flex', alignItems: 'center' }}>
            <DateRangePicker
                format= 'DD/MM/YYYY'
                ref={inputDatePickerCCRef}
                initialSettings={{
                    singleDatePicker: true,
                    showDropdowns: true,
                    timePicker: false,
                    autoApply: true,
                    maxDate: maxDate,
                    startDate: moment().toDate(),
                    endDate: moment().toDate(),
                    locale: {
                        format: 'DD/MM/YYYY',
                        cancelLabel: t('filter.dateRange.cancel'),
                        applyLabel: t('filter.dateRange.apply'),
                        daysOfWeek: [
                            t('dateRangePicker.Su'),
                            t('dateRangePicker.Mo'),
                            t('dateRangePicker.Tu'),
                            t('dateRangePicker.We'),
                            t('dateRangePicker.Th'),
                            t('dateRangePicker.Fr'),
                            t('dateRangePicker.Sa'),
                        ],
                        monthNames: [
                            t('dateRangePicker.January'),
                            t('dateRangePicker.February'),
                            t('dateRangePicker.March'),
                            t('dateRangePicker.April'),
                            t('dateRangePicker.May'),
                            t('dateRangePicker.June'),
                            t('dateRangePicker.July'),
                            t('dateRangePicker.August'),
                            t('dateRangePicker.September'),
                            t('dateRangePicker.October'),
                            t('dateRangePicker.November'),
                            t('dateRangePicker.December'),
                        ],
                    },
                }}
                onHide={handleHide}
            >
                <input
                    type="text"
                    className='date-picker-cc'
                    id='date-picker-cc'
                    format= 'DD/MM/YYYY'
                    onClick={handleFocusInput}
                />
            </DateRangePicker>
            <TooltipCC title={t('pickDateRange')} >
                <IconButton sx={{ p: 0.5 }} onClick={handleOpenDatepickerCC}>
                    <IconCalendarDatePicker />
                </IconButton>
            </TooltipCC>
        </Box>
    )
}

export default DatePickerCC